import React from 'react';
import PropTypes from 'prop-types';
import { Tooltip } from '@mui/material';
import HelpIcon from '@mui/icons-material/Help';
import { useTheme } from '@mui/material/styles';

const Description = ({ children }) => {
    const theme = useTheme();
    return (
        <Tooltip title={children} sx={{ backgroundColor: theme?.palette.background.default }}>
            <HelpIcon
                sx={{
                    fontSize: '1.0rem',
                    verticalAlign: 'super',
                    color: theme.palette.primary.main,
                }}
            />
        </Tooltip>
    );
};

Description.propTypes = {
    children: PropTypes.node,
};

export default Description;
